/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetManifestDynamicEnumOptionsPathParams = NonNullable<
  operations['getManifestDynamicEnumOptions']['parameters']['path']
>;

export interface Input extends GetManifestDynamicEnumOptionsPathParams {
  apiVersion?: string;
}

export async function getManifestDynamicEnumOptions(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/integration-manifests/{integrationKey}/dynamic-options/{dynamicEnumKey}', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
